import {getRestRoute, getSetting} from "@wc-stripe/utils";
import apiFetch from "@wordpress/api-fetch";
import actions from '@wc-stripe/actions';

class Order {

    constructor(props) {
        this.data = props;
        this.actions = actions;
    }

    /**
     *
     * @param payment_method
     * @param data
     * @returns {Promise<unknown>}
     */
    async processPayment(payment_method, data = {}) {
        return apiFetch({
            method: 'POST',
            url: getRestRoute('order/pay'),
            data: {
                payment_method,
                ...{
                    order_id: this.getId(),
                    order_key: this.getOrderKey()
                },
                ...data,
            }
        }).then(response => response);
    }

    needsShipping() {
        return this.actions.applyFilters('order_needs_shipping', false, this);
    }

    getCurrency() {
        return this.data.currency;
    }

    getTotal() {
        return this.data.total || 0.00;
    }

    getTotalCents() {
        return parseInt(this.data.totalCents || 0);
    }

    getLineItems() {
        return this.data.lineItems || [];
    }

    getId() {
        return this.data.order_id;
    }

    getOrderKey() {
        return this.data.order_key;
    }

    getBillingName() {
        return this.data.billing_address.name
    }

    getBillingEmail() {
        return this.data.billing_address.email;
    }

    getBillingPhone() {
        return this.data.billing_address.phone;
    }

    getBillingAddress() {
        return this.data.billing_address;
    }
}

export default new Order(getSetting('order'));